import { NotepadIcon } from '@rsos/assets/icons';
import { ActionBarItem } from '../ActionBarItem';
import useOutboundSMSHelpers from './useOutboundSMSHelpers';

const OutboundSMSActionBarItem = () => {
  const { handleOutboundSMSClick, isTF911Enabled, isOutboundSMSCardOpened } =
    useOutboundSMSHelpers();

  return (
    <ActionBarItem
      iconWidth="16px"
      shouldRender={isTF911Enabled}
      onClick={handleOutboundSMSClick}
      tooltipText="Text New Phone Number"
      isActive={isOutboundSMSCardOpened}
      iconDataName="outbound-sms-action-bar-item-icon"
    >
      <NotepadIcon />
    </ActionBarItem>
  );
};

export default OutboundSMSActionBarItem;
